import { useState } from 'react';
import { useDebounceFn } from 'ahooks';
import { useCappsRenterPropertyAddressesWebApiHandler_autocomplete } from '@zg-rentals/ts-capps-client-react-query';
import type { RenterAddressAutocompleteWebComponentDto } from '@zg-rentals/ts-capps-client';

export const MIN_AUTOCOMPLETE_ADDRESS_LENGTH = 7;
export const MAX_AUTOCOMPLETE_ADDRESS_LENGTH = 100;

export type AddressResponse = RenterAddressAutocompleteWebComponentDto;

export function useAddressAutocomplete({ initialAddress = '' }: { initialAddress?: string }) {
  const [partialAddress, setPartialAddress] = useState(initialAddress);
  const [partialAddressDebounced, setPartialAddressDebounced] = useState(initialAddress);
  const { run: setAddressAutocompleteDebounced } = useDebounceFn(setPartialAddressDebounced, { wait: 300 });

  function onSetAddress(address: string) {
    setPartialAddress(address);
    setAddressAutocompleteDebounced(address);
  }

  const trimmedAddress = partialAddressDebounced.trim();
  const queryHook = useCappsRenterPropertyAddressesWebApiHandler_autocomplete(
    { partialAddress: trimmedAddress },
    {
      enabled:
        trimmedAddress.length >= MIN_AUTOCOMPLETE_ADDRESS_LENGTH &&
        trimmedAddress.length <= MAX_AUTOCOMPLETE_ADDRESS_LENGTH,
      meta: { tags: ['addressAutocomplete'] },
    },
  );

  return [partialAddress, onSetAddress, queryHook] as const;
}
